<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_administrative') }}
    </p>
    <hr />
    <div class="row" v-for="(_, index) in model.nManagementRoles" :key="index">
      <select-component
        :dataOptions="managementRoles"
        :initialSelection="model.mgmt_roles[index]"
        :isMultiple="false"
        :indexSelect="index"
        :labelSelect="`${$t('common_words.administrative_role')}: `"
        :rowClass="'col-6'"
        :requireClass="'required-mgmt-roles'"
        @onChange="onInputChange"
        @onClear="model.mgmt_roles[index] = null"
        modelName="mgmt-roles"
      />
      <select-component
        :dataOptions="users"
        :initialSelection="model.mgmt_users[index]"
        :indexSelect="index"
        :labelSelect="`${$t('common_words.associated_users2')}: `"
        :rowClass="'col-4'"
        :requireClass="'required-mgmt-users'"
        @onChange="onInputChange"
        @onClear="model.mgmt_users[index] = []"
        modelName="mgmt-users"
      />
      <div class="col-1 mt-4">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handlePlus()"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
      <div class="col-1 mt-4">
        <div class="text-left">
          <label style="color: transparent">{{
            $t('common_words.options')
          }}</label>
          <button
            class="btn btn-secondary custom-shadow-btn"
            @click="handleMinus(index)"
          >
            <em class="fa fa-minus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      users: null,
      managementRoles: null,
      model: {
        nManagementRoles: 1,
        mgmt_roles: [],
        mgmt_users: [],
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  computed: {},

  methods: {
    /** Maneja cambios en los inputs dinámicos del formulario. */
    onInputChange(data) {
      try {
        switch (data.name) {
          case 'mgmt-roles':
            if (Array.isArray(this.model.mgmt_roles)) {
              this.$set(this.model.mgmt_roles, data.index, data.selects);
            }

            break;
          case 'mgmt-users':
            if (Array.isArray(this.model.mgmt_users)) {
              this.$set(this.model.mgmt_users, data.index, data.selects);
            }

            break;
          default:
            this.$set(this, data.name, data.selects);

            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            mgmtRolesSelected: this.model.mgmt_roles
              ? this.getNameSelected(
                  this.model.mgmt_roles,
                  this.managementRoles
                )
              : null,
            mgmtRolesUsersSelected: this.model.mgmt_users
              ? this.getAllMgmtUserSelected(this.model.mgmt_users, this.users)
              : null,
          });
        })
        .then(() => {
          for (let i = 0; i < this.model.nManagementRoles; i++) {
            if (
              isset(this.model.mgmt_users[i]) &&
              !isset(this.model.mgmt_roles[i])
            ) {
              return this.validationInputsRequired('mgmt-roles');
            } else if (
              isset(this.model.mgmt_roles[i]) &&
              !isset(this.model.mgmt_users[i])
            ) {
              return this.validationInputsRequired(
                'mgmt-users',
                false,
                false,
                true
              );
            }
          }

          return true;
        });
    },

    handleMinus(index) {
      if (this.model.nManagementRoles === 1) {
        this.model.mgmt_roles = [];
        this.model.mgmt_users = [];
      } else if (this.model.nManagementRoles > 1) {
        this.model.nManagementRoles--;
        const fieldsToRemove = ['mgmt_roles', 'mgmt_users'];

        fieldsToRemove.forEach((field) => {
          this.removeArrayItem(this.model, field, index);
        });
      }
    },

    handlePlus() {
      if (this.model.nManagementRoles < this.managementRoles.length) {
        this.model.nManagementRoles++;
        this.model.mgmt_roles.push(null);
        this.model.mgmt_users.push([]);
      }
    },

    getAllMgmtUserSelected(model, origin) {
      const res = model
        .slice(0, this.model.nManagementRoles)
        .map((selectedModel, index) => {
          return this.getNameSelected(selectedModel, origin);
        });

      return res;
    },

    handleEditForm(editForm) {
      let management_roles = editForm.management_roles;
      if (management_roles.length > 0) {
        management_roles.forEach((element) => {
          const indice = this.managementRoles.findIndex(
            (value) => value.id === element.id
          );

          if (!this.model.mgmt_roles.includes(element.id)) {
            this.model.mgmt_roles.push(element.id);

            // Convertir el objeto de usuarios en un array de IDs
            const userIds = Object.keys(element.users).map((userId) =>
              parseInt(userId)
            );
            this.$set(this.model.mgmt_users, indice, userIds);
          } else {
            // Si ya existe el rol, concatenar los IDs de usuarios
            const userIds = Object.keys(element.users).map((userId) =>
              parseInt(userId)
            );
            this.model.mgmt_users[indice].push(...userIds);
          }
        });

        this.model.nManagementRoles = this.model.mgmt_roles.length;
      }
    },
  },

  created() {
    this.showHideLoading(true);
    Promise.all([
      Axios.getMasters('users/indexfield'),
      Axios.getMasters('managementroles'),
    ])
      .then(([usersResponse, farmsMgmtRolesResponse]) => {
        this.users = this.concatAll(usersResponse.data.data);
        this.managementRoles = farmsMgmtRolesResponse.data.data;

        if (this.isUpdate() && sessionStorage.getItem('editForm')) {
          this.handleEditForm(JSON.parse(sessionStorage.getItem('editForm')));
        }

        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        SweetAlert.warning(error.response.data.message);
      });
  },
};
</script>
